// XSS 방어: 외부 입력(게시된 맵/책)에서 온 URL을 화이트리스트 검증(CLAUDE.md 불변식 7).
// javascript:·vbscript:·data:text/html 등 활성 스킴을 렌더/이동 전에 차단.

/** 외부 링크용 안전 URL: http(s) 또는 동일 출처 상대경로(/...)만. 그 외 undefined. */
export function safeHttpUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (trimmed.startsWith("/") && !trimmed.startsWith("//")) return trimmed; // 동일 출처 상대경로
  try {
    const u = new URL(trimmed);
    return u.protocol === "http:" || u.protocol === "https:" ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

/** 이미지 src용 안전 URL: http(s)·상대경로에 더해 data:image/ (더미 임베드 폴백) 허용. */
export function safeImageUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  if (url.trim().startsWith("data:image/")) return url.trim();
  return safeHttpUrl(url);
}

/** 동영상 src용 안전 URL: http(s)·상대경로에 더해 data:video/ (임베드 폴백) 허용. */
export function safeVideoUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  if (url.trim().startsWith("data:video/")) return url.trim();
  return safeHttpUrl(url);
}

/** 음성 src용 안전 URL: http(s)·상대경로에 더해 data:audio/ 허용. */
export function safeAudioUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  if (url.trim().startsWith("data:audio/")) return url.trim();
  return safeHttpUrl(url);
}
